import { conditionMessages } from './condition-messages.js'
import { enumOptionsJa } from './enum-options.js'
import { sectionCatalogJa } from './section-catalog.js'

export const ja = {
  visualGameStudio: {
    brand: 'Visual Game Studio',
    localizationUnsupported: 'この過去バージョンには完全なコンパイルデータがないため、多言語化できません。別のバージョンを選択してください。',
    seal: '劇',
    viewport: {
      title: 'より大きな画面で使用してください',
      body: 'Visual Game Studio はデスクトップ向けの制作ツールです。幅 1024px 以上の画面で作品を編集してください。',
    },
    nav: { projects: '作品', editor: '編集', assets: '素材', versions: '版', turnVideos: 'ターン動画', runChain: 'プレイ連鎖', localization: '多言語', help: 'ヘルプ', settings: '設定' },
    auth: { title: 'Studio にログイン', subtitle: 'プラットフォームアカウントで作品、素材、版、公開を管理します。', email: 'メール', password: 'パスワード', login: 'ログイン', logout: 'ログアウト', loggingIn: 'ログイン中', failed: 'ログイン失敗' },
    topbar: { preview: 'プレビュー', publish: '公開', noProject: '作品未選択', account: 'アカウント' },
    projects: {
      title: '自分の作品',
      subtitle: 'visual-game の下書き、公開状態、可視性を管理します。',
      tags: 'タグ', bulkTags: '一括タグ', bulkTagsPlaceholder: 'Fantasy, Romance, Mystery', applyToFiltered: '絞り込み {count} 件に適用', bulkTagsApplied: '{count} 件のタグを更新しました',
      newProject: '新規作品',
      search: '作品を検索',
      filterAll: 'すべて',
      filterDraft: '下書き',
      filterPublished: '公開済み',
      sortUpdated: '更新順',
      sortEpisode: 'レベル順',
      levelNumber: 'レベル {number}',
      emptyTitle: '作品はまだありません',
      emptyBody: '最初の物語パックを作成して構造化編集に入ります。',
      edit: '編集',
      duplicate: '複製',
      rename: '名前変更',
      visibility: '可視性',
      delete: 'アーカイブ/削除',
      createTitle: '新規作品',
      editTitle: '作品情報を編集',
      projectTitle: 'タイトル',
      seriesId: 'シリーズ ID',
      seriesIdPlaceholder: '例: painted_skin',
      seriesTitle: 'シリーズ名',
      scriptTitle: '脚本名',
      seriesTitlePlaceholder: '例: Painted Skin',
      episodeNo: 'レベル番号',
      episodeNoPlaceholder: '1',
      seriesHint: '単独レベルは3項目を空欄にしてください。シリーズに追加する場合はすべて入力し、番号はシリーズ内で重複できません。',
      newSeries: '脚本を作成',
      createSeries: '脚本を作成',
      createSeriesTitle: '新規脚本',
      createSeriesHint: '脚本の作成時に最初のレベルも作成されます。後から脚本内でレベルを追加できます。',
      firstLevelTitle: '最初のレベル名',
      firstLevelTitlePlaceholder: '例：寺に入る',
      seriesCreated: '脚本と最初のレベルを作成しました',
      seriesSection: '脚本',
      standaloneSection: '単独レベル',
      manageLevels: 'レベル管理',
      levelCount: '{count} レベル',
      newLevel: 'レベルを追加',
      newStandalone: '単独レベルを作成',
      backToSeries: '脚本一覧へ戻る',
      seriesLevelsSubtitle: 'この脚本の {count} レベルを順番に管理します。',
      belongsToSeries: '所属脚本',
      searchLevels: 'この脚本のレベルを検索',
      searchStandalone: '単独レベルを検索',
      noMatchingLevels: '該当するレベルはありません',
      locale: '言語',
      associateLevel: '既存レベルを関連付け',
      associateLevelTitle: '単独レベルを関連付け',
      associateLevelHint: 'コピーを作成せず内容も変更せず、元の単独レベルを {series} に追加します。',
      standaloneLevel: '単独レベル',
      selectStandaloneLevel: '単独レベルを選択',
      levelAssociated: 'レベルを脚本に関連付けました',
      associateLevelFailed: 'レベルの関連付けに失敗しました',
      private: '非公開',
      public: '公開',
      unlisted: '限定公開',
      save: '保存',
      cancel: '取消',
      creating: '作成中',
      saving: '保存中',
      loading: '作品を読み込み中',
      loadFailed: '作品の読み込みに失敗',
      createFailed: '作成失敗',
      updateFailed: '保存失敗',
      duplicateFailed: '複製失敗',
      deleteFailed: '削除失敗',
      created: '作品を作成しました',
      updated: '作品を保存しました',
      duplicated: '作品を複製しました',
      archived: '作品をアーカイブしました',
      deleted: '作品を削除しました',
      confirmDelete: 'この操作を実行しますか。公開済みまたはユーザーデータがある場合はアーカイブされ、未使用の下書きは完全削除されます。',
      confirmTextLabel: '確認するには {title} を入力',
      scenes: '場面',
      endings: '結末',
      updatedAt: '更新',
    },
    status: { draft: 'DRAFT', published: 'PUBLISHED', archived: 'ARCHIVED', unknown: 'UNKNOWN' },
    enumOptions: enumOptionsJa,
    sectionGroups: { basic: '基本', state: '数値と状態', world: '世界', cast: '人物と物', info: '情報', gameplay: '遊び方', ending: '結末', assets: '素材' },
    editor: {
      title: '脚本編集',
      subtitle: 'セクションごとに地図、人物、任務、規則、結末、素材を管理します。',
      section: 'セクション',
      readonly: 'この作品の編集権限がありません',
      unsaved: '未保存',
      saved: '保存済み',
      save: '保存',
      revert: '戻す',
      savedToast: 'セクションを保存しました',
      saveFailed: '保存失敗',
      discardConfirm: '未保存の変更を破棄しますか。',
      discardTitle: '未保存変更を破棄',
      discardBody: 'この section には未保存の変更があります。離れるとデータベースへ保存されません。',
      stayEditing: '編集を続ける',
      discardCta: '変更を破棄',
      deleteEntityTitle: '項目を削除',
      deleteEntityBody: 'この項目は現在の section から削除され、保存後にデータベースへ反映されます。',
      deleteEntityBlocked: 'この項目は {count} 箇所で参照されています。参照を削除してから実行してください。',
      deleteEntityConfirmLabel: '{label} と入力して削除を確認してください。',
      deleteEntityCta: '削除する',
      recentChanges: '最近の変更',
      recentChangesHint: 'この下書きのデータベース監査記録を表示します。',
      auditLoading: '変更を読み込み中',
      auditLoadFailed: '変更の読み込みに失敗しました',
      noRecentChanges: '変更はまだありません',
      auditActions: { section_update: 'section 保存', asset_upload: '素材アップロード', asset_delete: '素材削除', compile: 'コンパイル', publish: '公開', rollback: 'ロールバック' },
      focusedCheck: '現在の公開チェック位置',
      structuredTab: '構造化',
      jsonTab: 'JSON',
      jsonHelp: 'JSON が正しく解析されると構造化フォームへ同期されます。',
      jsonInvalid: 'JSON が不正です',
      addRow: '追加',
      searchOptions: 'Search options',
      dragRow: 'ドラッグして並べ替え',
      duplicateRow: '複製',
      removeRow: '削除',
      emptyRows: '行なし',
      item: '項目',
      noId: 'ID 未設定',
      sections: {
        mapLocations: '地点',
        mapGraph: '地点接続図',
        npcs: 'NPC',
        objects: '物件',
        clues: '手がかり',
        conclusions: '結論',
        infoBlocks: '情報ブロック',
        sceneEvents: '場面イベント',
        actionRules: '行動ルール',
        endings: '結末',
        stateRegistry: '状態辞書',
        players: 'プレイヤー',
        quests: '任務',
        mediaTags: '素材タグ',
        videoReferences: '動画生成用設定画像',
        stageRules: 'ステージ規則',
        audioRules: '音声規則',
        voiceSettings: '音声設定',
        voiceSettingsHelp: 'まずデフォルト音声を設定します。各言語列は実行時の音声を上書きでき、空欄ならデフォルトを継承します。',
        audioMoodRules: 'BGM 規則',
        statSfxRules: '数値効果音',
        stateCgRules: '状態 CG 規則',
        followupRules: '後続 CG',
      },
      stateWorkspace: {
        initialTitle: '開始時の実値',
        initialBody: '新しい run 作成時にここの値が書き込まれます。全体 flag、NPC 状態、任務進捗、物件状態、初期所持品などです。',
        registryTitle: '状態辞書',
        registryBody: '状態 key の説明書です。各 key の意味、書き込み元、読み取り元、影響する物語やルールを記録します。',
        relationshipTitle: '関係',
        relationshipBody: '開始値は「開始時に何が真か」を決めます。辞書は「その key が何か」を説明します。辞書は開始値の代替ではなく、公開チェック、ルール参照、保守に使います。',
        openingValues: '開始値',
        registeredKeys: '登録 key',
        initialHint: '開始時に必ず存在する値だけを置きます。NPC や物件のネスト状態は辞書 key と合わせやすいようドットパスで表示します。',
        registryHint: '行動ルール、条件、KP、Agent が読む状態 key は登録してください。出典と影響が明確だと後の調査が楽になります。',
        registryTableTitle: '状態辞書項目',
        unregisteredInitialKeys: '辞書説明がまだない開始 key:',
        keyPurpose: '用途',
        noRegistryNote: '用途未登録',
        noRegistryHint: '下の状態辞書に同じ key を追加すると、意味と実行時影響がここに表示されます。',
      },
      sceneWorkspace: {
        scenesGroup: '場面',
        emptyScenes: 'まだ場面がありません。先に地図で地点を追加してください。',
        noScene: '先に地図で場面を作成してください。',
        noDescription: 'この場面にはまだ説明がありません。',
        unlocked: '開始時に解放',
        locked: '未解放',
        sceneObjects: 'この場面の物件定義',
        sceneClues: 'この場面の手がかり',
        sceneInfoBlocks: 'この場面の情報',
        sceneEvents: 'この場面のイベント',
        sceneActionRules: 'この場面のルール',
        npcNote: 'この場面に登場する全体 NPC を選び、場面開始時の状態を編集します。完全な人物設定は全体 NPC 定義に残ります。',
        objectNote: 'この場面に配置する全体物件を編集します。物件定義は全体 objects、配置は map.locations[].objectIds に保存されます。',
        clueNote: '現在の場面に関連する全体手がかりを絞り込みます。新規手がかりはこの場面に自動で紐づきます。',
        infoNote: 'この場面の NPC に属する情報ブロックだけを表示します。',
        eventNote: '現在の場面のイベントだけを表示します。保存時に locationId はこの場面になります。',
        ruleNote: '現在の場面に関連する行動ルールだけを表示します。新規ルールには location 条件を自動追加します。',
        tabs: {
          overview: '概要',
          basic: '基本',
          connections: '接続',
          npcs: 'NPC',
          objects: '物件',
          clues: '手がかり',
          infoBlocks: '情報',
          sceneEvents: 'イベント',
          actionRules: 'ルール',
        },
        hints: {
          basic: '場面名、説明、種類、素材。',
          connections: 'この場面から他の場面への移動関係。',
          npcs: 'この場面にいる NPC と開始時状態。',
          objects: 'この場面に配置された全体物件と定義。',
          clues: 'この場面、NPC、物件に関連する手がかり。',
          infoBlocks: '場面 NPC が持つ公開可能情報と隠し事実。',
          sceneEvents: 'この場面に属する入場、発見、カスタムイベント。',
          actionRules: 'この場面の対象または location 条件に関係するルール。',
        },
      },
      mediaUsage: {
        title: 'Media usage',
        subtitle: 'Shows where each media asset is bound in the game flow. Saving writes these bindings into structured tables used by the game runtime.',
        missingAsset: 'This tag is missing from the asset manifest',
        opening: 'Home opening CG',
        endingBook: 'Ending book background',
        entryStage: 'Entry stage',
        entryStageIdle: 'Entry idle video',
        defaultStage: 'Default stage',
        defaultStageIdle: 'Default idle video',
        revealedStage: 'Revealed stage',
        revealedStageIdle: 'Revealed idle video',
        defaultBgm: 'Default BGM',
        editInMedia: 'Edit in Media global rules',
        editInMediaStageRules: 'Edit in Media stage rules',
        editInMediaAudioRules: 'Edit in Media audio rules',
        editInMediaStateCgs: 'Edit in Media state CG rules',
        editInMediaFollowups: 'Edit in Media follow-ups',
        editInMap: 'Edit in Map location media',
        editInNpcs: 'Edit in NPC media tag',
        editInPlayers: 'Edit in Player character portrait',
        editInEndings: 'Edit in Ending CG',
      },
      sectionCatalog: sectionCatalogJa,
      fieldGroups: {
        public: '公開層',
        secret: '秘密層',
        secretBadge: '秘密・プレイヤー非表示',
      },
      fields: {
        id: 'ID',
        name: '名前',
        type: '種類',
        state: '状態',
        label: 'ラベル',
        scope: 'スコープ',
        source: '出典',
        detail: '詳細',
        summary: '概要',
        prerequisiteConclusions: '前提となる結論',
        relatedClues: '関連する手がかり',
        content: '内容',
        priority: '優先度',
        target: '対象',
        targetType: '対象種類',
        mode: 'モード',
        intent: '意図',
        claim: '主張',
        claims: '意味的な主張',
        mediaTag: 'Media tag',
        referenceAssets: 'Reference assets',
        stageMediaTags: 'Stage portraits',
        phaseKey: 'Stage',
        tag: 'Tag',
        file: 'ファイル',
        objectKey: 'Object key',
        mime: 'MIME',
        width: '幅',
        height: '高さ',
        packId: 'Pack ID',
        title: 'タイトル',
        tagline: '短い説明',
        assetManifestId: '素材 manifest ID',
        videoSceneReferenceTag: 'シーン設定画像',
        videoNpcReferenceTag: 'NPC 設定画像',
        videoPlayerReferenceTag: 'プレイヤー設定画像',
        coverTag: '横向きカバー（縦向き未設定時）',
        portrait_cover_tag: '縦向きカバー（9:16）',
        opening: '冒頭テキスト',
        seoTitle: '一覧タイトル',
        seoDescription: '一覧概要',
        initialLocation: '初期地点',
        none: '未選択',
        initialPhase: '初期 phase',
        turnLimit: 'ターン上限',
        openingStrategy: '開始方式',
        defaultActionMode: '既定行動モード',
        statsDefinitions: '数値定義',
        statId: 'ID',
        statName: '名前',
        statColor: '色',
        initialValue: '初期値',
        description: '説明',
        statRules: '数値ルール',
        initialStates: '初期状態',
        stateKey: '状態キー',
        stateValue: '状態値',
        initialFlags: '初期 flags',
        initialNpcStates: '初期 NPC 状態',
        initialQuestStates: '初期任務状態',
        initialSceneEventStates: '初期事件状態',
        initialObjectStates: '初期物件状態',
        initialInventory: '初期所持品',
        primaryNpcId: '主要 NPC',
        keeperRole: 'KP 役割',
        dynamicStoryEnabled: '動的ストーリーを有効化',
        singleScene: '単一場面モード',
        minDistinctTurns: '最小有効ターン数',
        maxActiveBranches: '同時進行分岐の上限',
        maxGeneratedEndings: '1 回の生成結末上限',
        trackerExpiry: '方向追跡の失効ターン',
        dynamicStoryPrinciples: '動的ストーリー原則',
        dynamicStoryForbidden: '動的ストーリー禁止事項',
        referenceEndings: '参考結末',
        referenceEndingsHint: '参考例は分岐生成器だけに渡され、通常の KP / NPC プロンプトには入りません。',
        referenceEnding: '参考結末',
        requiredConsequences: '必須の結果',
        phaseRules: 'Phase ルール',
        phase: 'Phase',
        principles: '進行原則',
        forbidden: '禁止規則',
        hiddenFacts: '隠し事実',
        displayName: '表示名',
        publicProfile: '公開プロフィール',
        trueProfile: '真のプロフィール',
        coverRole: '偽装役割',
        coverStory: '偽装物語',
        coverAttitude: '偽装態度',
        species: '種族',
        origin: '由来',
        hunger: '欲求',
        limitation: '制限',
        danger: '危険',
        appearance: '外見',
        publicKnowledge: '公開知識',
        privateKnowledge: '秘匿知識',
        disclosePolicy: '開示方針',
        boundaries: '境界',
        mustDo: '必須行動',
        mustNotDo: '禁止行動',
        usable: '使用可',
        damaged: '破損',
        known: '既知',
        importance: '重要度',
        ownerNpc: '所有 NPC',
        startsUnlocked: '初期解放',
        unlockWhen: '解放条件',
        speakableAs: '発話例',
        locationId: '地点 ID',
        once: '一度のみ',
        triggerWhen: '発火条件',
        whenCondition: '一致条件',
        requires: '前提条件',
        invalidReason: '無効理由',
        overrideKp: 'KP 上書き',
        stopProcessing: '後続停止',
        targetsAll: '全対象',
        effectsStats: '数値変化',
        effectsFlags: '設定 flags',
        effectsEvidence: '追加証拠',
        locationChange: '移動先',
        unlockLocations: '解放地点',
        lockLocations: 'ロック地点',
        addInventory: '追加所持品',
        removeInventory: '削除所持品',
        sceneNarration: '場面叙述',
        visibleFindings: '見える発見',
        discoveredObjects: '発見物件',
        npcReaction: 'NPC 反応方針',
        npcDirectiveNpc: '指定 NPC',
        npcDirectiveTactic: 'NPC 戦術',
        npcDirectiveMood: 'NPC 感情',
        mustReactTo: '必ず反応',
        mustHide: '必ず隠す',
        possibleEnding: '即時結末',
        reason: '理由',
        valueType: '値型',
        hardState: '硬い状態',
        writers: '書き手',
        readers: '読み手',
        runtimeEffect: '実行時効果',
        notes: 'メモ',
        npcIds: 'NPC IDs',
        objectIds: '物件 IDs',
        sceneEventIds: 'イベント IDs',
        connections: '接続',
        to: '行き先',
        locked: 'ロック',
        lockedReason: 'ロック理由',
        defaultCharacterId: '既定キャラ',
        showInSelection: 'キャラクター選択に表示',
        gender: '性別',
        age: '年齢',
        archetype: '原型',
        portraitTag: '立ち絵素材',
        attributes: '属性',
        skills: '技能',
        inventory: '所持品',
        history: '経歴',
        traits: '特性',
        mainQuestId: '主任務',
        statusAtStart: '初期状態',
        steps: '手順',
        completeWhen: '完了条件',
        failWhen: '失敗条件',
        entryTag: 'Entry tag',
        entryIdleTag: 'Entry idle tag',
        defaultTag: 'Default tag',
        defaultIdleTag: 'Default idle tag',
        revealedTag: 'Revealed tag',
        revealedIdleTag: 'Revealed idle tag',
        openingTag: 'Opening CG tag',
        endingBookTag: 'Ending book tag',
        idleTag: 'Idle video tag',
        mood: 'Mood',
        statKey: 'Stat key',
        triggerType: 'Trigger type',
        statePath: 'State path',
        threshold: 'Threshold',
        oncePerRun: 'Once per run',
        triggerScope: 'Trigger scope',
        sortOrder: 'Sort order',
        defaultBgmTag: 'Default BGM tag',
        defaultBgmMood: 'Default BGM mood',
        voiceRole: '役割',
        defaultVoice: 'デフォルト音声',
        inheritDefaultVoice: 'デフォルトを継承',
        playerVoiceId: 'プレイヤー音声',
        npcVoiceId: 'NPC 音声',
        endingVoiceId: 'エンディング音声',
      },
    },
    conditions: conditionMessages.ja,
    assets: {
      title: '素材',
      subtitle: '立ち絵、CG、音声、参照を管理します。',
      file: 'ファイル',
      search: 'tag、MIME、object key を検索',
      upload: '素材をアップロード',
      uploading: 'アップロード中',
      uploaded: '素材をアップロードしました',
      uploadFailed: 'アップロード失敗',
      generateImage: 'AI で画像を生成',
      generatingImage: '画像を生成中',
      imageGenerated: '画像を生成して素材に保存しました',
      imageGenerationFailed: '画像の生成に失敗しました',
      image_purpose: '画像の用途',
      image_purpose_asset: '通常素材',
      image_purpose_portrait_cover: '縦向きカバー',
      portrait_cover_hint: '9:16 の縦向きカバー（1080 × 1920）を生成します。生成後、シナリオ設定で縦向きカバーとして選択してください。',
      imagePrompt: '画像の説明',
      imagePromptHint: 'Seedream で 2K 画像を1枚生成し、このパックの素材に保存します。',
      deleted: '素材を削除しました',
      delete: '素材を削除',
      deleteFailed: '削除失敗',
      openFile: 'ファイルを開く',
      inspect: '確認',
      inspector: '素材インスペクター',
      selectAsset: '素材を選択するとプレビュー、メタ情報、参照を確認できます。',
      noPreview: 'プレビューはありません',
      noMetadata: 'メタ情報なし',
      loading: '素材を読み込み中',
      loadFailed: '素材の読み込みに失敗しました',
      emptyTitle: '最初の立ち絵または CG をアップロード',
      empty: '素材はまだありません',
      duplicateTag: 'この tag は既に存在します。別の tag を指定してください。',
      referenceCount: '{count} 件の参照',
      references: '参照',
      noReferences: 'この素材を参照している section はありません。',
      confirmDeleteTitle: '素材を削除',
      confirmDeleteBody: 'この素材は現在の下書きから削除されます。',
      confirmReferencedDeleteBody: 'この素材は {count} 箇所で参照されています。削除すると参照が壊れます。',
      confirmTextLabel: '削除を確認するには {tag} を入力',
      confirmDeleteCta: '削除する',
      coverage: {
        total: '素材総数',
        referenced: '物語で使用',
        unreferenced: '未使用',
        unreferencedTags: '未使用の素材 tag',
        none: 'すべての素材が物語フィールドから参照されています。',
      },
      filters: { all: 'すべて' },
      groups: { cg: 'CG・カットシーン', character: 'キャラクター・立ち絵', scene: 'シーン・参考', audio: '音楽・効果音', ui: 'UI 素材', reference: '参考画像', other: 'その他ファイル' },
      types: { image: '画像', video: '動画', audio: '音声', asset: 'ファイル' },
      meta: { type: '種類', mime: 'MIME', dimensions: 'サイズ', objectKey: 'Object key', hash: 'Hash' },
    },
    versions: { title: '版', subtitle: 'コンパイル、検証、公開、ロールバック、プレビュー。', compile: '下書きをコンパイル', compiling: 'コンパイル中', compileDone: 'コンパイル完了', compileFailed: 'コンパイル失敗', loadChecksFailed: '公開チェックの読み込みに失敗しました', publishDone: '版を公開しました', publishFailed: '公開失敗', previewFailed: 'プレビュー認証に失敗しました', rollback: 'ロールバック', rollbackDone: 'ロールバックしました', rollbackFailed: 'ロールバック失敗', checks: '公開チェック', noChecks: '選択した版にはまだチェックがありません。下書きをコンパイルするか版を選択してください。', version: '版', emptyTitle: '版はまだありません', empty: '版はまだありません。先に下書きをコンパイルしてください。', publishBlocked: '公開をブロックするチェックを修正してください。', jumpToSection: 'Section を開く', snapshot: 'コンパイルスナップショット', openSnapshot: 'スナップショットを見る', closeSnapshot: 'スナップショットを閉じる', noSnapshot: 'この版には表示できるコンパイルスナップショットがありません。', checkStatus: { ok: '通過', warning: '警告', error: 'エラー', empty: 'チェックなし' }, checkSummary: { ok: 'すべてのチェックに通過しました。', warning: '{warnings} 件の警告があります。', error: '{errors} 件のブロック項目があります。', empty: 'チェックは未読み込みです。' }, confirm: { publishTitle: '版を公開', publishBody: '公開後、プレイヤー側はこの版をライブ版として使用します。', publishCta: '公開する', rollbackTitle: '版をロールバック', rollbackBody: 'ライブ版を選択した版へ切り替えます。既存のプレイヤーデータは削除されません。', rollbackAcknowledge: 'ライブ版が切り替わることを理解し、続行します。', rollbackCta: 'ロールバック' } },
    localization: { title: 'ゲームコンテンツの多言語化', description: '選択した版ごとに翻訳を手動で生成・更新します。下書き保存時には自動翻訳しません。', externalNotice: '生成すると、この版の物語テキストが設定済み翻訳モデルへ送信され、結果が翻訳テーブルに保存されます。', sourceSummary: 'この版には {count} 件の翻訳対象テキストがあります。', loading: '翻訳状態を読み込み中…', loadFailed: '翻訳状態の読み込みに失敗しました', generate: '翻訳を生成', generateAll: 'すべての言語を生成（{count}）', generatingAll: 'すべての言語を生成中…', batchProgress: '{total} 言語中 {current} 件目を処理中 · {completed} 件完了', generateAllDone: '{count} 言語の翻訳が完了しました', generateAllFailed: '一括翻訳完了：{completed} 件成功、{failed} 件失敗', allAlreadyDone: 'すべての言語が完了しています', regenerate: '再生成', generating: '生成中…', generateDone: '翻訳を生成しました', generateFailed: '翻訳生成に失敗しました', progressLoadFailed: '翻訳は継続中ですが、進捗を一時的に取得できません', progressStatus: { idle: '準備中', translating: '翻訳中', saving: '保存中', completed: '完了', failed: '失敗' }, status: { source: '原文の言語', missing: '未処理', ready: '完了' }, locales: { 'zh-CN': '簡体字中国語', en: '英語', ja: '日本語', ko: '韓国語', es: 'スペイン語', pt: 'ポルトガル語' } },
    translationInventory: { title: 'コンテンツ詳細', all: 'すべて', pending: '翻訳待ち', reused: '旧訳を再利用', translated: '翻訳済み', source: '原文', target: '対象言語の訳文', notTranslated: '未翻訳', empty: 'この条件に一致するコンテンツはありません。', reuseFrom: '変更のない内容は {version} から再利用されます。', reusableCount: '{count} 件再利用可能', pendingCount: '{count} 件翻訳待ち' },
    common: { retry: '再試行', refresh: '更新', open: '開く', close: '閉じる', more: 'その他', required: '必須' },
  },
}
